import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Box)`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const MainWrapper = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
}));

export const FooterWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$clearMobileBar",
})<{ $clearMobileBar?: boolean }>(({ theme, $clearMobileBar = true }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",

  [theme.breakpoints.down(910)]: {
    paddingBottom: $clearMobileBar ? 52 : 0,
  },
}));
